import styled from "styled-components";

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
`;

export default Card;
